import { SectionHeading } from '@/features/invoice_reports/components/InvoiceReportDetailDrawer/components/SectionHeading';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { ApplicationDetail } from './ApplicationDetail';

type ApplicationContentProps = {
  reportId: string;
};

export const ApplicationContent: FC<ApplicationContentProps> = memo(
  ({ reportId }) => {
    const { t } = useTranslation();

    return (
      <SectionHeading title={t('application_content.section_title')}>
        <ApplicationDetail reportId={reportId} />
      </SectionHeading>
    );
  }
);
ApplicationContent.displayName = 'ApplicationContent';
